/*
Copyright (c) 2012-2025 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/

const CACHE_EXPIRY_SECONDS = 30 // Cache failed images for 30 seconds

/**
 * Cache for failed WebP image URLs with 30-second expiry
 * Uses a Map to store failed URLs (key) with timestamps (value)
 */
const failedWebPImages = new Map<string, number>()

/**
 * Check if an image has failed to load and is still within expiry time
 */
const isImageFailed = (url: string): boolean => {
  if (!url) return false

  const timestamp = failedWebPImages.get(url)
  if (!timestamp) {
    return false
  }

  const now = Date.now()
  const expiryTime = CACHE_EXPIRY_SECONDS * 1000

  if (now - timestamp > expiryTime) {
    failedWebPImages.delete(url)
    return false
  }

  return true
}

/**
 * Add a failed image to the cache with current timestamp
 */
const addFailedImage = (url: string): void => {
  if (!url) return

  failedWebPImages.set(url, Date.now())
}

/**
 * Clear all failed images from the cache
 */
const clearFailedImages = (): void => {
  failedWebPImages.clear()
}

const webPImageCache = {
  isImageFailed,
  addFailedImage,
  clearFailedImages,
}
export default webPImageCache
